/**
 * Points de position pour les rangées défilantes (sélecteur de tables, vidéos clients).
 *
 * Une rangée qui déborde ne se voit pas sur mobile : on ne devine pas qu'il faut
 * glisser. Les points rendent visible le nombre de cartes ET la position actuelle,
 * et servent aussi de raccourci au clic.
 *
 * Balisage attendu :
 *   <div data-zm-carousel>   ← le conteneur qui défile
 *     <article|li> … </article|li>
 *   </div>
 *   <div data-zm-dots></div> ← rempli ici
 *
 * Les points sont masqués quand tout tient à l'écran (rien à faire défiler).
 */
(function () {
  'use strict';

  if (window.__zoemassCarousel) return;
  window.__zoemassCarousel = true;

  /**
   * Les cartes réellement affichées. Une rangée peut porter un enfant masqué
   * (la tuile WhatsApp du sélecteur de tables, réservée à la grille mobile) :
   * compté, il ajoutait un point qui ne menait nulle part.
   */
  function cards(track) {
    return Array.prototype.slice.call(track.children).filter(function (card) {
      return card.offsetParent !== null;
    });
  }

  /** Index de la carte dont le centre est le plus proche du centre visible. */
  function activeIndex(track) {
    var center = track.scrollLeft + track.clientWidth / 2;
    var best = 0;
    var bestGap = Infinity;

    cards(track).forEach(function (card, i) {
      var gap = Math.abs(card.offsetLeft + card.offsetWidth / 2 - center);
      if (gap < bestGap) {
        bestGap = gap;
        best = i;
      }
    });

    return best;
  }

  /**
   * Marque la carte centrée. Sur un écran tactile il n'y a pas de survol :
   * c'est ce marquage qui met en valeur la carte qu'on est en train de regarder.
   */
  function markCurrent(track, index, scrollable) {
    cards(track).forEach(function (card, i) {
      card.classList.toggle('is-current', scrollable && i === index);
    });
  }

  function setup(track) {
    var dots = track.parentElement && track.parentElement.querySelector('[data-zm-dots]');
    var items = cards(track);
    var scrollable = track.scrollWidth - track.clientWidth > 4;

    markCurrent(track, activeIndex(track), scrollable);

    if (!dots) return;

    dots.hidden = !scrollable || items.length < 2;
    if (dots.hidden) {
      dots.innerHTML = '';
      return;
    }

    if (dots.children.length !== items.length) {
      dots.innerHTML = '';
      items.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'zm-dot';
        dot.setAttribute('aria-label', 'Aller à la carte ' + (i + 1) + ' sur ' + items.length);
        dot.addEventListener('click', function () {
          track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      });
    }

    var update = function () {
      var index = activeIndex(track);
      markCurrent(track, index, true);
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };

    update();

    if (!track.dataset.zmBound) {
      track.dataset.zmBound = 'true';
      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            update();
            ticking = false;
          });
        },
        { passive: true }
      );
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-zm-carousel]').forEach(setup);
  }

  function initAll() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // La largeur des cartes change avec la fenêtre : les points peuvent devenir inutiles.
  window.addEventListener('resize', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
